module.exports = __webpack_public_path__ + "img/airport_hover_aa413b2.webp";